const MonthAll = [
    {id: "1", value: "1月份"},    
    {id: "2", value: "2月份"},
    {id: "3", value: "3月份"},
    {id: "4", value: "4月份"},    
    {id: "5", value: "5月份"},
    {id: "6", value: "6月份"},
    {id: "7", value: "7月份"},    
    {id: "8", value: "8月份"},
    {id: "9", value: "9月份"},
    {id: "10", value: "10月份"},    
    {id: "11", value: "11月份"},
    {id: "12", value: "12月份"},            
  ];  
  
  export default MonthAll  